import { useQuery } from "react-query";

import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

/**
 * The savings plan types a fund can be — `Enums.InvestmentTypes` on the API.
 *
 * `name` is the enum spelling ("FlexySave") and `description` is what a person
 * should read ("Flexy Save"), so the form shows the description.
 *
 * Fetched rather than hardcoded: the list is the backend's to extend, and a
 * fund does not have to be one of them — plenty of investment products are
 * created outside the four savings plans.
 */
export type TInvestmentPlanType = {
  id: number;
  name: string;
  description: string;
};

const getInvestmentPlanTypes = async (): Promise<TInvestmentPlanType[]> => {
  const data = await getDataWithDotNet(ajaxEndpoints.GET_INVESTMENT_PLAN_TYPES);

  return data?.data ?? [];
};

export default function useInvestmentPlanTypes() {
  return useQuery<TInvestmentPlanType[]>(
    "getInvestmentPlanTypes",
    getInvestmentPlanTypes,
    { refetchOnWindowFocus: false },
  );
}
